import { Component, Input, OnInit } from '@angular/core';

import { Response } from './shared/response.model';

@Component({
  selector: 'app-goverment-fees',
  templateUrl: './goverment-fees.component.html',
  styleUrls: ['./goverment-fees.component.css']
})
export class GovermentFeesComponent {
  @Input()
  response: Response;

  constructor() {}

  get total(): number {
    let sum = 0;
    this.response.governmentFeesAndTaxes.forEach(lineItem => {
      sum += lineItem.amount;
    });
    return sum;
  }
}
